import { render, staticRenderFns } from "./ApiKeyPermissionsSummary.vue?vue&type=template&id=00cb390f&"
import script from "./ApiKeyPermissionsSummary.vue?vue&type=script&lang=js&"
export * from "./ApiKeyPermissionsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports